// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
import Vue from 'vue'

import VueFire from 'vuefire'
import firebase from 'firebase'

import ShardApp from './ShardApp'
import ShardHero from './components/shard-hero'
import LoginForm from './components/login-form'

import router from './router'

import PolygonCircle from './assets/js/polygon-circle'

Vue.config.productionTip = false

// Setup Firebase
// Initialize Firebase
var config = {
  apiKey: 'AIzaSyAx-9aHm9ZmGSJLJ0pKcoIKZ-SI1VViqF8',
  authDomain: 'shardstudio-3583f.firebaseapp.com',
  databaseURL: 'https://shardstudio-3583f.firebaseio.com',
  projectId: 'shardstudio-3583f',
  storageBucket: 'shardstudio-3583f.appspot.com',
  messagingSenderId: '952496924589'
}
firebase.initializeApp(config)

/* eslint-disable no-new */
new Vue({
  el: '#shard-app',
  router,
  template: '<shard-app/>',
  components: {
    ShardApp
  }
})



// WEBPACK FOOTER //
// ./src/main.js